import React from "react";
import {
  Card, Box,
  Chip,
  CardActionArea,
  CardContent,
  Typography,
  CardMedia, Grid,
} from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import {getModuleTypeColor} from "../../../../../utils/displayUtils";
import { modulePackageName } from "../../../../../utils/displayUtils";
import {getModuleThumbnail} from "../../../../../config/moduleThumbnails";
import ImageWithCredit from "../../../../common/ImageWithCredit";
import EstimatedTimeIcon from "../../../../common/EstimatedTimeIcon";

export default function ModuleCard({
  selectedModules,
  activeModuleIndex,
  selectedTemplatesFromRedux, width, imageHeight
}) {
  const activeModule = { ...selectedModules[activeModuleIndex - 1] };
  // console.log('selectedModule', selectedTemplatesFromRedux[activeModuleIndex])

  const malArray = [];
  activeModule.totalTime = 0;
  if(activeModuleIndex)
  {
    if (selectedTemplatesFromRedux[activeModuleIndex]?.trainingIsActive) {
      malArray.push("Trening");
      activeModule.totalTime += parseInt(activeModule.trainingEstimatedTime) || 0;
    }
    if (selectedTemplatesFromRedux[activeModuleIndex]?.testIsActive) {
      malArray.push("Test");
      activeModule.totalTime += parseInt(activeModule.testEstimatedTime) || 0;
    }
    if (selectedTemplatesFromRedux[activeModuleIndex]?.theoryIsActive) {
      malArray.push("Teori");
      activeModule.totalTime += parseInt(activeModule.teoriEstimatedTime) || 0;
    }
    console.log("activeModuleIndex: " + activeModuleIndex);
    console.log("totalTime: " + activeModule.totalTime);
  }

  const moduleThumb = getModuleThumbnail(activeModule.name) || {};
  const moduleImage = moduleThumb.url || activeModule.image || "";
  const creditImage = moduleThumb.creditImage || activeModule.creditImage ||  null;

  const malString = malArray.length > 0 ? malArray.join(" ") : "-";
  console.log(activeModule)

  return (
    <Card sx={{ width:{width}}}>
      <CardActionArea>
        <ImageWithCredit
            image={moduleImage}
            alt={activeModule?.name  + "" || ""}
            creditImage={creditImage}
            overlaySize={40}
            overlayPosition={{top: 0, right: 10}}
            height={imageHeight}
        />
        <CardContent>
          <Grid container alignItems="center" justifyContent="space-between">
            <Grid item>
              <Typography sx={{ fontWeight: 600, color: "#707070", fontSize: 14 }}>
                {activeModule?.name}
              </Typography>
            </Grid>
            <EstimatedTimeIcon totalTime={activeModule?.totalTime} />
          </Grid>
        {/*<Box display="flex" justifyContent="space-between" alignItems="center" px={2} py={1}>*/}
        {/*    <Typography sx={{ fontWeight: 600, color: "#707070", fontSize: 14 }}>*/}
        {/*        {activeModule?.name}*/}
        {/*    </Typography>*/}
        {/*    /!*<AccessTimeIcon fontSize="small" sx={{ color: "#707070" }}/>*!/*/}
        {/*    /!*<Typography sx={{ fontSize: 13, color: "#bdbdbd" }}>*!/*/}
        {/*    /!*  {activeModule?.totalTime} min*!/*/}
        {/*    /!*</Typography>*!/*/}
        {/*</Box>*/}
          <Chip
            label={`${modulePackageName(activeModule?.moduleType)}`}
            sx={{
              backgroundColor: activeModule?.moduleType ? getModuleTypeColor(activeModule.moduleType) : "#ccc",
              color: "#fff",
              fontSize: 11,
              mb: 1,
            }}
          />
          <Typography
            sx={{ fontWeight: 600, color: "#616161", my: 1, fontSize: 14 }}
          >
            {selectedTemplatesFromRedux[activeModuleIndex]?.name}
          </Typography>
          <Typography variant="caption" display="block" gutterBottom>
            Mal : {malString}
          </Typography>
          <Typography
            variant="caption"
            display="block"
            sx={{ fontSize: 12, color: "#757575" }}
          >
            Krav til godkjent trening:{" "}
            {selectedTemplatesFromRedux[activeModuleIndex]?.trainingIsActive
                ? selectedTemplatesFromRedux[activeModuleIndex]?.generalSuccessPercentage
                    ? selectedTemplatesFromRedux[activeModuleIndex]?.generalSuccessPercentage + "%"
                    : " -"
                : " -"
            }
          </Typography>
          <Typography
            variant="caption"
            display="block"
            sx={{ fontSize: 12, color: "#757575" }}
          >
            Krav til godkjent test:{" "}
            {selectedTemplatesFromRedux[activeModuleIndex]?.testIsActive
                ? selectedTemplatesFromRedux[activeModuleIndex]?.testApprovalPercentage
                    ? selectedTemplatesFromRedux[activeModuleIndex]?.testApprovalPercentage + "%"
                    : " -"
                : " -"
            }
          </Typography>
          <Typography
            variant="caption"
            display="block"
            sx={{ fontSize: 12, color: "#757575" }}
          >
            Antall pasienter:{" "}
            {selectedTemplatesFromRedux[activeModuleIndex]?.patientCount
              ? selectedTemplatesFromRedux[activeModuleIndex]?.patientCount
              : " -"}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
